function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { organization_team_list_path, RouteNames } from '@ui/routes';
import { getItemPath } from '@ui/utils';
import { Link } from '../Link';
import { CardFooter } from '../card-footer';
import { AvatarList } from '../card-item-elements';
import { ItemCounter } from '../item-counter';
import { VisibilityTag } from '../visibility-tag';
function ApplicationItem(param) {
    let { application, authUserName, gitTags } = param;
    var _application_deletedAt;
    const { organization, project } = application;
    const isPrivate = 'isPrivate' in application ? application.isPrivate : 'visibility' in project ? project.visibility === 'private' : false;
    const hostPlatform = 'hostPlatform' in application ? application.hostPlatform : undefined;
    const contributors = 'contributors' in application ? application.contributors : [];
    return /*#__PURE__*/ _jsxs("div", {
        className: "w-full bg-bg-primary-default px-4 py-3 border-b border-border",
        "data-e2e": "application-item",
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "flex flex-row items-center justify-between",
                "data-e2e": "application-item-stack",
                children: [
                    /*#__PURE__*/ _jsxs("div", {
                        className: "w-4/5 flex items-center gap-2",
                        "data-e2e": "application-item-left-side-info",
                        children: [
                            /*#__PURE__*/ _jsx(VisibilityTag, {
                                label: isPrivate ? 'private' : 'public'
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                className: "flex items-center gap-2",
                                children: /*#__PURE__*/ _jsxs("p", {
                                    className: "m-0 text-tx-secondary-default text-base font-medium leading-[150%] cursor-default w-max",
                                    children: [
                                        /*#__PURE__*/ _jsx(Link, {
                                            className: "text-white no-underline text-base",
                                            to: RouteNames.ORGANIZATION,
                                            params: {
                                                organization: organization.name
                                            },
                                            children: organization.name
                                        }),
                                        "\xa0/\xa0",
                                        /*#__PURE__*/ _jsx(Link, {
                                            className: "text-white no-underline text-base",
                                            to: RouteNames.PROJECT_OVERVIEW,
                                            params: {
                                                organization: organization.name,
                                                project: project.name
                                            },
                                            children: project.displayName
                                        }),
                                        "\xa0/\xa0",
                                        /*#__PURE__*/ _jsx(Link, {
                                            className: "no-underline text-base",
                                            to: RouteNames.APPLICATION_OVERVIEW,
                                            params: {
                                                organization: organization.name,
                                                project: project.name,
                                                application: application.name
                                            },
                                            search: {
                                                gitTags: gitTags === null || gitTags === void 0 ? void 0 : gitTags.join(',')
                                            },
                                            children: application.name
                                        })
                                    ]
                                })
                            }),
                            ' ',
                            /*#__PURE__*/ _jsx(Link, {
                                to: RouteNames.APPLICATION_VERSIONS,
                                className: "no-underline",
                                params: {
                                    organization: organization.name,
                                    project: project.name,
                                    application: application.name
                                },
                                children: /*#__PURE__*/ _jsx(VisibilityTag, {
                                    label: "Versions"
                                })
                            }),
                            /*#__PURE__*/ _jsx(ItemCounter, {
                                counters: application.counters,
                                hostPlatform: hostPlatform,
                                params: {
                                    organization: organization.name,
                                    project: project.name,
                                    application: application.name
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "flex gap-6",
                        "data-e2e": "application-item-right-data",
                        children: /*#__PURE__*/ _jsx(AvatarList, {
                            list: getAvatarList({
                                contributors,
                                organization: organization.name,
                                authUserName
                            }),
                            limitedRightDataItemHref: organization_team_list_path({
                                organization
                            }),
                            showElse: true,
                            showAmount: 3
                        })
                    })
                ]
            }),
            !!application.description && /*#__PURE__*/ _jsx("div", {
                className: "max-w-160",
                children: /*#__PURE__*/ _jsx("span", {
                    className: "block text-ellipsis overflow-hidden text-tx-secondary-alt whitespace-nowrap text-sm",
                    children: application.description
                })
            }),
            /*#__PURE__*/ _jsx("div", {
                children: /*#__PURE__*/ _jsx(CardFooter, {
                    deletedAt: (_application_deletedAt = application.deletedAt) !== null && _application_deletedAt !== void 0 ? _application_deletedAt : undefined,
                    updatedAt: application.updatedAt
                })
            })
        ]
    });
}
const getAvatarList = (param)=>{
    let { contributors, organization, authUserName } = param;
    if (!(contributors === null || contributors === void 0 ? void 0 : contributors.length)) {
        return [];
    }
    return contributors.map((item)=>{
        var _item_name, _item_avatarColor, _item_username;
        const safeContributor = _object_spread_props(_object_spread({}, item), {
            name: (_item_name = item.name) !== null && _item_name !== void 0 ? _item_name : '',
            avatarColor: (_item_avatarColor = item.avatarColor) !== null && _item_avatarColor !== void 0 ? _item_avatarColor : undefined,
            username: (_item_username = item.username) !== null && _item_username !== void 0 ? _item_username : undefined
        });
        return _object_spread_props(_object_spread({}, safeContributor), {
            href: getItemPath(_object_spread({
                authUserName,
                organization
            }, safeContributor)),
            imageSrc: '/'
        });
    });
};
export { ApplicationItem };
